module.exports = __webpack_public_path__ + "static/media/4.20b90424.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/400/4.png
// module id = 737
// module chunks = 0